(function (moo, $, undefined) {
	let self = this,
		$document = $(document)
	;
	this.afterLoad = function () {
		console.log("metsakindlustus afterLoad");

	};

	$document.on("click", ".show-buy-contacts", function () {

		$(".add-auction-step-four").show();

		return false;
	});

	$document.on("change", "#metsauuendustood-select", function () {
		let $this = $(this),
			val = $this.val()
		;
		console.log("metsauuendustood", val);

		if (val === 'jah') {
			$("#metsauuendustood").show();
		} else {
			$("#metsauuendustood").hide();
		}
	});

	$document.on("change", "#objekt_laenu_tagatis-select", function () {
		let $this = $(this),
			val = $this.val()
		;
		console.log("objekt_laenu_tagatis", val);

		if (val === 'jah') {
			$("#registrikood_wrapper").show();
			$("[name=\"registrikood\"]").prop("required",true);
		} else {
			$("#registrikood_wrapper").hide();
			$("[name=\"registrikood\"]").prop("required",false);
		}
	});

	$document.on("click", ".auction-send-question", function () {
		let $this = $(this),
			$form = $this.closest("form"),
			url = $form.attr("action"),
			question = $("#auction-question").val()
		;

		$.post(url, {question: question}, function (result) {
			if (result) {
				if (result.status) {
					$("#auction-question").val("");

					$(".popup-overlay").hide();

					$(".popup-overlay").addClass("popup-overlay-locked");
					$("[data-popup=\"ask-info-popup-ok\"]").show();
				}
			}
		}, "json");

		return false;
	});

	var dateToday = new Date();
	let datePickerSettings = {
		monthNames: ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni",
			"Juuli", "August", "September", "Oktoober", "November", "Detsember"
		],
		dayNamesMin: ["P", "E", "T", "K", "N", "R", "L"],
		dateFormat: "dd.mm.yy",
		firstDay: 1,
		showOn: "both",
		buttonText: "<i class='fas fa-calendar'></i>",
		minDate: 1,
		beforeShow: function () {
			$(this).siblings(".datepicker-wrapper").append($("#ui-datepicker-div"));
		}
	};
	$(".datepicker").datepicker(
		datePickerSettings
	);

	$document.ready(function () {
		console.log("metsakindlustus ready");

		self.afterLoad();
	});
}(window.metsakindlustus = window.metsakindlustus || {}, jQuery));
